import { useCallback, useState } from 'react'

export default function useIsFocused({ autoSelect = false, onFocus, onBlur }) {
  let [isFocused, setIsFocused] = useState(false)

  let onFocusBind = useCallback(
    (event) => {
      setIsFocused(true)
      onFocus && onFocus(event)

      // needed because native doesn't support select on focus
      if (autoSelect && typeof event.target?.select === 'function') {
        event.target.select()
      }
    },
    [autoSelect, onFocus]
  )
  let onBlurBind = useCallback(
    (event) => {
      setIsFocused(false)
      onBlur && onBlur(event)
    },
    [onBlur]
  )

  return [isFocused, onFocusBind, onBlurBind]
}
